﻿import { mapGetters, mapState } from 'vuex';

export default {
    name: 'service-logo',
    template: '<svg role="img" class="ts-symbol--block" aria-hidden="true"><use :xlink:href="logo" /></svg>',
    props: ['logo'],
    methods: {

    },
    created: function () {

    }
}
